// EXAMPLE INPUT: 'Mon 2pm-8pm\nTue 2pm-8pm\nWed 2pm-8pm\nThu 2pm-8pm\nFri 2pm-8pm'

interface Map {
  [key: string]: string;
}

const dayMap: Map = {
  Mon: 'Monday',
  Tue: 'Tuesday',
  Wed: 'Wednesday',
  Thu: 'Thursday',
  Fri: 'Friday',
  Sat: 'Saturday',
  Sun: 'Sunday',
};

const mapJobSchedule = (data: string) => {
  if (data?.length > 0) {
    // Convert the string to an array of days
    const scheduleArray = data.split('\n');

    // Separate the Days from Times in two arrays
    const scheduleDayArray = scheduleArray.map((str) => str.split(' ')[0]);
    const scheduleTimeArray = scheduleArray.map((str) => str.split(' ')[1]);

    // Reformat the days to be full strings
    const scheduleDayArrayMapped = scheduleDayArray.map((key) => {
      return dayMap[key];
    });

    return { scheduleDayArrayMapped, scheduleTimeArray };
  }
  return { scheduleDayArrayMapped: [], scheduleTimeArray: [] };
};

export default mapJobSchedule;
